import toFinite from "./component-library235.mjs";
function toInteger(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
export {
  toInteger as default
};
